import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGear } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from "react-router-dom";
import { useContext } from 'react';
import GeneralContext from '../../contexts/GeneralContext';
import "./MenuTab.css"

function SlidingSettingsTab() {
    const route = useNavigate(); // variable to help route to different page
    const {setCurrentTab, currentTab} = useContext(GeneralContext)
    const route_style = (e) => {
      //   route("/style");
      setCurrentTab("Settings")
      route('/main/settings/account')
    }

    return (
      <div className="slidetab">
         <div className={`slide-innertab ${(currentTab == 'Settings') && 'innerTabActive'}`}>
            <div className="slidetab-icontab" onClick={route_style}>
               <FontAwesomeIcon icon={ faGear } className="iconTab" />
            </div>
            <p className="slidetab-text" onClick={route_style}>Settings</p>
         </div>
      </div>
   )
}

export default SlidingSettingsTab
